import { Injectable } from '@angular/core';
import { LotGeneration } from '../models';
import { environment } from 'src/environments/environment';
import { catchError, map } from 'rxjs/operators';
import { BaseApiService } from './baseApiService';
import { StorageKey } from './storage.service';

export interface LotGenerationPayload {
  preProcessSettingsId: number;
  contractId: number;
  lotGeneration: {
    stopAttribution?: boolean;
    namePattern?: string;
    pathPattern?: string;
    autoGeneration: Array<any>;
  };
  lotSteps?: Record<string, any>;
  violationSteps?: Record<string, any>;
}

@Injectable({
  providedIn: 'root'
})
export class LotGenerationService extends BaseApiService<LotGeneration> {
  get cacheKey(): StorageKey {
    return StorageKey.lotGenerationServiceCache;
  }

  getUrl(operation: string, params, id: string = null): string {
    let url = `${environment.omniaCoreApiUrl}/v1/lotGeneration`;
    if (id != null) {
      url = url + '/' + encodeURIComponent(id);
    }
    return url;
  }

  protected unparse(obj) {
    return LotGeneration.unparse(obj);
  }

  protected parse(obj) {
    return LotGeneration.parse(obj);
  }

  createOrUpdate(lotGenerationId: number, payload: LotGenerationPayload): Promise<LotGeneration> {
    const url = this.getUrl('createOrUpdate', null, lotGenerationId ? String(lotGenerationId) : null);
    const req = lotGenerationId ? this.http.put(url, payload) : this.http.post(url, payload);
    return req.pipe(
      catchError(this.handleError),
      map(res => this.unparse(res))
    ).toPromise().then(model => this.setCache(model.id, model));
  }

  removeById(id: number, preProcessSettingsId: number): Promise<void> {
    const url = this.getUrl('delete', null, String(id));
    return this.http.delete(url, { body: { preProcessSettingsId } }).pipe(
      catchError(this.handleError)
    ).toPromise().then(() => {
      this.setCache(id, undefined);
    });
  }

  resolveLotGeneration(lotGenerationId: number | null, force: boolean = false): Promise<LotGeneration> {
    if (lotGenerationId == null) {
      return Promise.resolve({ autoGeneration: [] } as any);
    }
    return this.getById(lotGenerationId as any, force);
  }
}
